import { render, staticRenderFns } from "./WptList.vue?vue&type=template&id=298ac830"
import script from "./WptList.vue?vue&type=script&lang=ts"
export * from "./WptList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports